import './styles.scss';

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ErrorMessage from 'Components/forms/helpers/ErrorMessage';

/**
 * From checkbox component
 * 
 * @example ./Styleguide.md
 */
export default class Checkbox extends Component {
    static propTypes = {
        name: PropTypes.string.isRequired,
        label: PropTypes.element.isRequired,
        required: PropTypes.bool,
        /* Unique className */
        className: PropTypes.string,
        onChange: PropTypes.func,
        value: PropTypes.bool,
        /* Error will be visible if is type of string */
        error: PropTypes.oneOfType([
            PropTypes.bool,
            PropTypes.string
        ])
    };
    static defaultProps = {
        required: false,
        className: '',
        onChange: () => { return false; },
        value: false,
        error: false
    };

    constructor(props) {
        super(props);

        this.state = {
            value: props.value
        };
    }

    onChange = (e) => {
        this.setState({
            ...this.state,
            value: e.target.checked
        });
        this.props.onChange(e.target.name, e.target.checked);
    }

    componentWillReceiveProps = props => {
        if (props.value !== this.props.value) {
            this.setState({
                ...this.state,
                value: props.value
            });
        }
    }

    render() {
        const { error } = this.props;
        const attrs = {
            name: this.props.name,
            label: this.props.label,
            required: this.props.required,
            className: this.props.className,
            value: this.props.value
        };
        return (
            <div className={`form-group checkbox ${error ? "error" : ""} ${attrs.name} ${attrs.className}`}>
                <label htmlFor={attrs.name}>
                    <input
                        type="checkbox"
                        id={attrs.name}
                        name={attrs.name}
                        required={attrs.required}
                        onChange={this.onChange}
                        value={this.state.value}
                        checked={this.state.value ? "checked" : ""}
                    />
                    <span className="button"></span>
                    <span className="label">{attrs.label}</span>
                </label>
                {typeof error === "string" ? <ErrorMessage type="checkbox" error={error} /> : ''}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/forms/Checkbox/index.js